import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "com_breadcrumb1" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbsListData, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.categoryId
        }, [
          (_ctx.dispTitle || (!_ctx.dispTitle && item.categoryId != _ctx.categoryId))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: `${item.categoryUrl}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.categoryName), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.categoryName), 1))
        ]))
      }), 128)),
      (_ctx.dispTitle)
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, _toDisplayString(_ctx.dispTitle), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}